export const matchProtocol = (url) => {
	console.log("param url (passed):", url)
	// url: string must be a url using http protocol
	// Default next url uses http protocol
	// If client is using https protocol, we replace to https on the param url J
	if (typeof window !== "undefined") {
		if (location && location.protocol.search(/https/) >= 0) {
			url = url.replace("http", "https")	 
		}
		console.log("param url (replaced):", url)
	}
	return url
	
};


// WEBPACK FOOTER //
// ./src/utils/matchProtocol.js